import { useEffect, useState } from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCalendarLinesPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DateInput from './DateInput';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/atoms/Popover';
import { cn } from '@/helpers/shadCnUtils';
interface DatePopupProps {
  dateText: string;
  onUpdateDate: (v: string) => void | Promise<void>;
  isLoading: boolean;
}

const DateInputPopup = ({ dateText, onUpdateDate, isLoading }: DatePopupProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setIsOpen(false);
    }
  }, [isLoading]);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div
          onClick={(e) => e.stopPropagation()}
          className={cn(
            '-mt-0.25 cursor-pointer text-gray-600 duration-150 hover:text-blue-600',
            isOpen && 'text-blue-600',
          )}
        >
          <FontAwesomeIcon icon={faCalendarLinesPen as IconProp} />
        </div>
      </PopoverTrigger>
      <PopoverContent side="right" className="z-20 max-w-72 rounded border bg-white p-3">
        <DateInput onUpdateDate={onUpdateDate} initialValue={dateText} isLoading={isLoading} />
      </PopoverContent>
    </Popover>
  );
};

export default DateInputPopup;
